import { useTranslation } from "next-i18next";
import { useEffect, useState } from "react";
import { SliceZone as SliceZoneComponent } from "@prismicio/react";
import { Text } from "@components/ui";
import { Content, SliceZone } from "@prismicio/client";
import { Simplify } from "@prismicio/types/dist/value/types";
import { PageHead } from "@components/commun";
import { components } from "../../../slices";
import style from "./FaqContent.module.scss";
import { SearchForm } from "./SearchForm";

type PageProps = {
  page: Content.PageFaqDocument | Content.PageFaqStagingDocument;
};

type TSlices = SliceZone<Content.FaqBlockSlice>;

export const FaqContent = ({ page }: PageProps) => {
  const { t } = useTranslation();
  const [filter, setFilter] = useState("");
  const [slices, setSlices] = useState<TSlices>(page.data.slices);

  const findWord = (item: Simplify<Content.FaqBlockSliceDefaultItem>) => {
    return (
      item.question?.includes(filter) === true || // @ts-ignore
      item.reponse.filter((rep) => rep.text.includes(filter)).length > 0
    );
  };

  useEffect(() => {
    if (filter !== "") {
      const rowsFiltred = page.data.slices.filter((slice) => {
        return slice.items.filter((item) => findWord(item)).length > 0;
      });

      const slicesFiltred = rowsFiltred.map((row) => {
        return {
          ...row,
          items: row.items.filter((item) => findWord(item)),
        };
      });
      // @ts-ignore
      setSlices(slicesFiltred);

      return;
    }
    setSlices(page.data.slices);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, page.data.slices]);

  return (
    <>
      <PageHead title={page.data.title} image={page.data.featureDesktop} />
      <div className={style.form}>
        <div className="lk-wrap">
          <div className="lk-wrap-content">
            <SearchForm filter={setFilter} />
          </div>
        </div>
      </div>
      <div className={style.content}>
        <div className="lk-wrap">
          <div className="lk-wrap-content">
            {slices.length > 0 ? (
              <SliceZoneComponent slices={slices} components={components} />
            ) : (
              <Text variant="p">{t("pages.noDataAvailable")}</Text>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
